import React from "react";
export default class TitleText extends React.Component<TitleTextProps, any>{

    render() {
        const style = $.extend({}, { color: "#515967" }, this.props.style);
        return (
            <div style={style}>{this.props.text}</div>
        );
    }
};

export interface TitleTextProps {
    text: string;
    style?: React.CSSProperties;
}